import {ActionElement, ValueEditor, ValueSelector} from "components/Homeowner/Dashboard/QueryBuilder/controls";
import {fontColor} from "components/Shared";
import {operatorNames} from "components/Homeowner/Dashboard/QuickListConfigOperatorNames";

// ReactQueryBuilder
export const operators = [
  {name: operatorNames.Equal, label: "EQUALS"},
  {name: operatorNames.NotEqual, label: "NOT EQUAL"},
  {name: operatorNames.LessThan, label: "LESS THAN"},
  {name: operatorNames.GreaterThan, label: "GREATER THAN"},
  {name: operatorNames.GreaterThanOrEqual, label: "GT EQUAL TO"},
  {name: operatorNames.LessThanOrEqual, label: "LT EQUAL TO"},
  {name: operatorNames.Empty, label: "EMPTY"},
  {name: operatorNames.NotEmpty, label: "NOT EMPTY"},
  {name: operatorNames.InList, label: "IN LIST"},
  {name: operatorNames.NotInList, label: "NOT IN LIST"},
  {name: operatorNames.Today, label: "TODAY"},
  {name: operatorNames.Overdue, label: "OVERDUE"},
  {name: operatorNames.True, label: "TRUE"},
  {name: operatorNames.False, label: "FALSE"},
  {name: operatorNames.Text, label: "TEXT"},
  {name: operatorNames.Range, label: "RANGE"},
];


// styling hide buttons: ruleGroup-addGroup, ruleGroup-combinators
// container class for a rule: .queryBuilder.rulegroup ... .rule
// set min-width: rule-operators
// make delete icon button: rule-remove

export const controlClassnames = {
  queryBuilder: "",

  ruleGroup: "",
  combinators: "",
  addRule: "",
  addGroup: "",
  removeGroup: "",

  rule: "",
  fields: "md-text",
  operators: "md-text",
  value: "md-text-field md-text",
  removeRule: "mbutton delete",
};

export const controlElements = {
  addGroupAction: null,
  removeGroupAction: ActionElement,
  addRuleAction: ActionElement,
  removeRuleAction: ActionElement,
  combinatorSelector: null,
  fieldSelector: ValueSelector,
  operatorSelector: ValueSelector,
  valueEditor: ValueEditor,
};

export const translations = {
  fields: {
    title: "Fields",
  },
  operators: {
    title: "Operators",
  },
  value: {
    title: "Value",
  },
  removeRule: {
    label: "",
    title: "Remove filter",
  },
  removeGroup: {
    label: "x",
    title: "Remove group",
  },
  addRule: {
    label: "Add Filter",
    title: "Add rule",
  },
  addGroup: {
    label: "Add Group",
    title: "Add group",
  },
  combinators: {
    title: "Combinators",
  },
};

// need to override styles for Query Builder.
// class queryButtonDelete <i class="md-icon material-icons dialog-button" title="Delete">delete</i>
// class queryButtonPrimary  make it smaller?
export const id2List = {
  droppable: "selectedList",
  droppable2: "unselectedList",
};

const colors = {
  background: "var(--dnd-bg-color)",
  border: fontColor.primary,
  borderColor: "var(--dnd-item-border)",
  draggingbg: "var(--fifth-color)",
  draggingbc: fontColor.primary,
};

export const getListStyle = isDraggingOver => ({
  background: `${isDraggingOver ? colors.draggingbg : colors.background}`,
  padding: 10,
  width: 340,
  borderColor: `${colors.borderColor}`,
  borderWidth: 1,
  borderStyle: "solid",
  height: "300px",
  overflow: "auto",
  boxSizing: "border-box",
});

export const getDefaultOperatorForSimpleMode = inputType => {
  switch (inputType) {
    case "UnderwriterCode":
    case "businessTypes":
    case "insurancecustomers":
    case "fieldStatus":
    case "states":
    case "extensiondays":
    case "HazardLevel":
    case "surveytypes":
      return operatorNames.InList;
  }
};
